import { render, staticRenderFns } from "./PricingJewellersBlockExcessLayer.vue?vue&type=template&id=b590d9c8"
import script from "./PricingJewellersBlockExcessLayer.vue?vue&type=script&lang=js"
export * from "./PricingJewellersBlockExcessLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports